import { FaThLarge, FaList } from 'react-icons/fa';

const BLOCK = 'LStudio__app_table';

/*
    🔥 LISTA O GRILLA

    ⚠️ NO SON DOS FORMAS DE VER LO MISMO: SIRVEN PARA COSAS DISTINTAS

    LISTA (tabla): para COMPARAR. Las columnas alineadas dejan recorrer
    una sola con la vista y ver quién tiene el total más alto, quién
    está pendiente. Entran muchos registros por pantalla.

    GRILLA (tarjetas): para RECONOCER. Cada registro es un bloque con
    su imagen o su avatar. Sirve cuando lo que importa es identificar
    uno, no compararlos. Entran menos, pero se distinguen mejor.

    Por eso conviene dejar elegir en vez de decidir por el usuario: un
    catálogo de productos se navega en grilla, un listado de facturas
    en lista.
*/

export const TABLE_VIEWS = [
    { id: 'list', label: 'Lista', icon: <FaList /> },
    { id: 'grid', label: 'Grilla', icon: <FaThLarge /> },
];

export const TableViewToggle = ({ value = 'list', onChange, views = TABLE_VIEWS }) => (

    <div className={`${BLOCK}__view_toggle`} role="group" aria-label="Forma de ver">
        {
            views.map((view) => (
                <button key={view.id} type="button"
                    className={`${BLOCK}__view_option`}
                    data-on={value === view.id}
                    title={view.label} aria-pressed={value === view.id}
                    onClick={() => onChange?.(view.id)} >
                    {view.icon}
                </button>
            ))
        }
    </div>
);
